import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';
import { LanguageService } from '../services/language.service';
import { TRANSLATIONS } from '../i18n/translations';

@Pipe({ name: 'translate', pure: false, standalone: false })
export class TranslatePipe implements PipeTransform, OnDestroy {
  private sub: Subscription;

  constructor(private langService: LanguageService, private cdr: ChangeDetectorRef) {
    this.sub = this.langService.lang$.subscribe(() => this.cdr.markForCheck());
  }

  transform(key: string): string {
    return TRANSLATIONS[this.langService.current]?.[key] ?? key;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
